import React from 'react';

import type { SupportedRepubName } from './types';

export type PaywallConfig = {
  cssClass: string;
  ctaClickTrackingProductName: 'Premium' | 'WhoScored Premium';
  ctaText: string;
  dataTemplate?: string;
  description: string;
  hasProductSelection: boolean;
  isSinglePriceTier: boolean;
  loginText: string;
  padlockImage: string;
  pricingLabel: string;
  shouldCtaClickOpenModal: boolean;
  testId: string;
  title: React.ReactNode;
};

export const PAYWALL_CONFIGS = {
  WS: {
    ctaText: 'Start 7-Day Free Trial',
    padlockImage: 'padlock-ws.svg',
    title: (
      <>
        BET WITH MORE INTELLIGENCE, MORE PROFITABLY,
        <br /> MORE OFTEN WITH WHOSCORED+
      </>
    ),
    description:
      'With over 41 million data points every week on WhoScored now powered by provably accurate AI projections, WhoScored+ helps you win more, more often with your soccer betting.',
    isSinglePriceTier: true,
    pricingLabel: 'Professional insights',
    ctaClickTrackingProductName: 'WhoScored Premium',
    dataTemplate: 'whoscored',
    loginText: 'Already subscribed? Please ',
    cssClass: 'wsPaywallCard',
    testId: 'ws-paywall',
    shouldCtaClickOpenModal: true,
    hasProductSelection: false, // WS has only one product option (Premium Monthly)
  },
  US: {
    ctaText: 'Start 7-Day Free Trial',
    padlockImage: 'padlock.svg',
    description:
      'Bet smarter with our full suite of cutting-edge tools and metrics designed to help you find long-term profitability.',
    hasProductSelection: true, // US: user selects between Monthly and Annual Premium
    pricingLabel: 'Less than £1 per day',
    ctaClickTrackingProductName: 'Premium',
    loginText: 'Already subscribed? Please ',
    title: (
      <>
        Gain access to <br />
        Industry-Leading Data and AI
      </>
    ),
    cssClass: 'padlockCard',
    testId: 'component-wall',
    shouldCtaClickOpenModal: false,
    isSinglePriceTier: true,
  },
  GZ: {
    ctaText: 'Inizia la prova gratuita di 14 giorni',
    padlockImage: 'padlock.svg',
    description:
      "Scommetti in modo più intelligente con la nostra suite completa di strumenti e metriche all'avanguardia progettati per aiutarti a trovare la redditività a lungo termine.",
    hasProductSelection: true,
    pricingLabel: 'Meno di €1 al giorno',
    ctaClickTrackingProductName: 'Premium',
    loginText: 'Sei già iscritto?',
    title: <>Ottieni accesso a dati e intelligenza artificiale leader del settore</>,
    cssClass: 'padlockCard',
    testId: 'component-wall',
    shouldCtaClickOpenModal: false,
    isSinglePriceTier: true,
  },
  OC: {
    ctaText: 'Start 7-Day Free Trial',
    padlockImage: 'padlock.svg',
    description:
      'Bet smarter with our full suite of cutting-edge tools and metrics designed to help you find long-term profitability.',
    hasProductSelection: true, // OC: user selects between Essential/Premium tiers AND Monthly/Annual terms
    pricingLabel: 'Less than £1 per day',
    ctaClickTrackingProductName: 'Premium',
    loginText: 'Have you already subscribed? Please ',
    title: 'Gain access to Industry-Leading Data and AI',
    cssClass: 'globalPaywallCard',
    testId: 'global-paywall',
    shouldCtaClickOpenModal: true,
    isSinglePriceTier: false,
  },
} satisfies Record<SupportedRepubName, PaywallConfig>;
